import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildRiskColumns } from './columns';
import { getRiskFields } from './fields';
import { getRiskSimpleFilters } from './simpleFilters';

/**
 * Risk QueryEntity - bundles columns and fields
 */
export const riskEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Risk', display: 'Vulnerability' },
  buildColumns:
    buildRiskColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getRiskFields,
  getSimpleFilters: getRiskSimpleFilters,
};
